import React from 'react';

const icons = {
  dashboard: (
    <>
      <path d="M4 13h6V4H4v9Z" />
      <path d="M14 20h6V4h-6v16Z" />
      <path d="M4 20h6v-3H4v3Z" />
    </>
  ),
  projects: (
    <>
      <path d="M3 7.5A2.5 2.5 0 0 1 5.5 5H10l2 2h6.5A2.5 2.5 0 0 1 21 9.5v7A2.5 2.5 0 0 1 18.5 19h-13A2.5 2.5 0 0 1 3 16.5v-9Z" />
      <path d="M3.5 10h17" />
    </>
  ),
  classes: (
    <>
      <path d="M5 4.5h10A4 4 0 0 1 19 8.5V20H7a2 2 0 0 1-2-2V4.5Z" />
      <path d="M7 4.5V18" />
      <path d="M9.5 8h6" />
      <path d="M9.5 11h5" />
    </>
  ),
  assignments: (
    <>
      <path d="M8 4h8l3 3v13H5V4h3Z" />
      <path d="M15.5 4.5V8h3.5" />
      <path d="M8.5 11h7" />
      <path d="M8.5 14h7" />
      <path d="M8.5 17h4" />
    </>
  ),
  materials: (
    <>
      <path d="M6 8h12v11H6V8Z" />
      <path d="M9 8V6a3 3 0 0 1 6 0v2" />
      <path d="M9 12h6" />
      <path d="M12 9v6" />
    </>
  ),
  disputes: (
    <>
      <path d="M12 4 21 20H3L12 4Z" />
      <path d="M12 9v5" />
      <path d="M12 17h.01" />
    </>
  ),
  mentors: (
    <>
      <path d="M8 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" />
      <path d="M2.5 20a5.5 5.5 0 0 1 11 0" />
      <path d="M17 10a2.5 2.5 0 1 0 0-5" />
      <path d="M15.5 15.5A4.5 4.5 0 0 1 21.5 20" />
    </>
  ),
  students: (
    <>
      <path d="M3 8 12 4l9 4-9 4-9-4Z" />
      <path d="M7 10.5V15c1.5 1.5 8.5 1.5 10 0v-4.5" />
      <path d="M20 9v5" />
    </>
  ),
  managers: (
    <>
      <path d="M7 8V6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2" />
      <path d="M4 8h16v11H4V8Z" />
      <path d="M9 12h6" />
    </>
  ),
  counsellors: (
    <>
      <path d="M4 6h16v10H8l-4 4V6Z" />
      <path d="M8 10h8" />
      <path d="M8 13h5" />
    </>
  ),
  competitions: (
    <>
      <path d="M8 4h8v3a4 4 0 0 1-8 0V4Z" />
      <path d="M8 6H4a4 4 0 0 0 4 5" />
      <path d="M16 6h4a4 4 0 0 1-4 5" />
      <path d="M12 11v5" />
      <path d="M9 20h6" />
      <path d="M10 16h4" />
    </>
  ),
  reports: (
    <>
      <path d="M6 4h9l3 3v13H6V4Z" />
      <path d="M14.5 4.5V8h3.5" />
      <path d="M9 16v-4" />
      <path d="M12 16v-7" />
      <path d="M15 16v-3" />
    </>
  ),
  approvals: (
    <>
      <path d="M20 11.3V12a8 8 0 1 1-4.7-7.3" />
      <path d="m9 11.5 2.2 2.2L20 5" />
    </>
  ),
  attendance: (
    <>
      <path d="M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" />
      <path d="M3.5 20a5.5 5.5 0 0 1 9.6-3.7" />
      <path d="m15 17 2 2 4-5" />
    </>
  ),
  utilization: (
    <>
      <path d="M4 14a8 8 0 1 1 16 0" />
      <path d="M12 14 16 9" />
      <path d="M8 20h8" />
      <path d="M12 18v2" />
    </>
  ),
  milestones: (
    <>
      <path d="M6 21V4" />
      <path d="M6 5h11l-2 4 2 4H6" />
    </>
  ),
  password: (
    <>
      <path d="M6 10h12v10H6V10Z" />
      <path d="M8.5 10V7.5a3.5 3.5 0 0 1 7 0V10" />
      <path d="M12 14v2" />
    </>
  ),
  logout: (
    <>
      <path d="M10 5H5v14h5" />
      <path d="M14 8l4 4-4 4" />
      <path d="M8 12h10" />
    </>
  ),
  search: (
    <>
      <path d="M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z" />
      <path d="m16 16 4 4" />
    </>
  ),
  info: (
    <>
      <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z" />
      <path d="M12 11v5" />
      <path d="M12 8h.01" />
    </>
  ),
};

const AppIcon = ({ name, className = '', size = 20, strokeWidth = 1.8 }) => {
  const icon = icons[name] || icons.info;

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {icon}
    </svg>
  );
};

export default AppIcon;
